<!-- =========================================================================================
    File Name: TodoItem.vue
    Description: Single todo item component
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
  <div @click="displayPrompt" class="px-4 py-4 list-item-component">
    <div class="vx-row">
      <div class="vx-col w-full sm:w-5/6 flex sm:items-center sm:flex-row flex-col">
        <div class="flex items-center">
          <div v-if="allowComplete">
            <feather-icon
              v-if="!taskLocal.isCompleted"
              icon="SquareIcon"
              class="cursor-pointer"
              svgClasses="w-5 h-5 mr-3"
              @click.stop="completeTask" />
            <feather-icon
              v-else
              icon="CheckSquareIcon"
              class="cursor-pointer"
              svgClasses="w-5 h-5 mr-3"
              @click.stop="uncompleteTask" />
          </div>
          <h6
            class="todo-title"
            :class="{ 'line-through': taskLocal.isCompleted }"
          >
            {{ taskLocal.name }}
          </h6>
        </div>
        <div v-if="displayStatus" class="todo-tags sm:ml-2 sm:my-0 my-2 flex">
          <vs-chip>
            <div
              class="h-2 w-2 rounded-full mr-1"
              :class="'bg-' + todoLabelColor(taskLocal.status)"
            ></div>
            <span>{{ $t('KPU.KPUStatus.' + taskLocal.status) }}</span>
          </vs-chip>
        </div>
      </div>

      <div class="vx-col w-full sm:w-1/6 ml-auto flex sm:justify-end">
        <feather-icon
          v-show="hasHistory"
          icon="ClockIcon"
          class="cursor-pointer mr-3"
          svgClasses="w-5 h-5"
          @click.stop="viewHistoryData()"
        />
        <feather-icon
          v-if="!taskLocal.isTrashed && allowDelete"
          icon="TrashIcon"
          class="cursor-pointer"
          svgClasses="w-5 h-5"
          @click.stop="moveToTrash"
        />
      </div>
    </div>
   
    <div class="vx-row" >
      <div v-if="taskLocal.desc" class="vx-col w-full sm:w-5/6 flex sm:items-center sm:flex-row flex-col">
        <p
          class="mt-2 truncate"
          :class="{ 'line-through': taskLocal.isCompleted }"
        >
          {{ taskLocal.desc }}
        </p>
      </div>
      <div v-if="displayDueDate" class="vx-col w-full sm:w-1/6 ml-auto flex sm:justify-end">
        <small class="mt-2"><i>{{$t('KPU.ToDo.DueDate')}} : {{ taskLocal.dueDate | toDate }}</i></small>
      </div>
    </div>
  </div>
</template>


<script>

import KPUStatusEnum from './../KPUStatusEnum.js'

export default {
  props: {
    taskId: {
      type: String,
      required: true
    },
    task: {
      type: Object,
      required: true
    },
    displayDueDate : {
      type: Boolean,
      default: false
    },
    displayStatus : {
      type: Boolean,
      default: true
    },
    allowDelete : {
      type:Boolean,
      default : true
    },
    allowComplete : {
      type:Boolean,
      default : true
    }
  },
  data() {
    return {
      taskLocal: Object.assign({}, this.task)
    };
  },
  watch : {
    task() {
      this.taskLocal = Object.assign({}, this.task)
    }
  },
  computed: {
    isCompleted: {
      get() {
        return this.taskLocal.isCompleted;
      },
      set(value) {
        this.taskLocal.isCompleted = value; 
        this.$emit("completeTask", this.taskLocal);
      } 
    },
    hasHistory() {
      return this.taskLocal.histories !== undefined && this.taskLocal.histories !== null;
    },
    todoLabelColor() {
      return (status) => {
        return this.getToDoLabelColor(status)
      };
    }
  },
  methods: {
    completeTask() {
      this.isCompleted = true;
    },
    uncompleteTask() {
      this.isCompleted = false;
    },
    moveToTrash() {
      this.$emit("deleteTask", this.taskLocal);
    },
    getToDoLabelColor(status) {
      if (!this.$props.displayStatus)
        return "primary";


      const statusId = parseInt(status);

      if (statusId === KPUStatusEnum.Ok)   return 'success'
      if (statusId === KPUStatusEnum.Warning) return 'warning'
    
      return 'danger'
    },
    getToDoIcon (status) {
      if (!this.$props.displayStatus)
        return "ClockIcon";

      const statusId = parseInt(status);

      if (statusId === KPUStatusEnum.Ok)   
        return 'ThumbsUpIcon'
      if (statusId === KPUStatusEnum.Warning) 
        return 'AlertTriangleIcon'
      
      return 'AlertOctagonIcon'
    },
    displayPrompt() {
      this.$emit("showDisplayPrompt", this.taskId);
    },
    viewHistoryData() {
      const historyData = [];

      if (this.hasHistory) 
      {
        this.taskLocal.histories.forEach(history => {
          historyData.push({
            icon : this.getToDoIcon(history.kpuStatus),
            color : this.getToDoLabelColor(history.kpuStatus),
            title :  history.name,
            desc : history.comments,
            time : this.$options.filters.toDate(history.submissionTime)
          })
        });
      }

      this.$emit("viewHistory", historyData);
    }
  }
};
</script>
